import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import FormContainer from './Forms/FormContainer';
import FormInput from './Forms/FormInput';
import { useNeuroMessages } from './MessageContext';
import {
  createRemoteSession,
  useDispatch
} from '../state';
import NeuroMessage from './NeuroMessage';

const RemoteSessionForm = ({ className, initialValue = null, onSubmit }) => {
  const appDispatch = useDispatch();
  const formId = 'remoteSession';
  const messageContext = useNeuroMessages();
  const classes = classnames(className, 'socialForm', 'remoteSessionForm');
  const [emailAddress, setEmailAddress] = useState(initialValue);

  const onFormChange = ({ emailAddress }) => {
    setEmailAddress(emailAddress);
  };

  const onFormSubmit = () => {
    appDispatch(createRemoteSession({ emailAddress }));
    onSubmit && onSubmit();
  };

  return (
    <section className={classes}>
      <NeuroMessage id="remoteSession.formBody" tagName="p" />
      <FormContainer
        onChange={onFormChange}
        onValidSubmit={onFormSubmit}
        formId={formId}
      >
        <FormInput
          formId={formId}
          initialValue={initialValue}
          name="emailAddress"
          required={true}
          validations="isEmail"
          validationError={messageContext.getMessage(
            'formInput.validationError.isEmail'
          )}
        />
      </FormContainer>
    </section>
  );
};
RemoteSessionForm.propTypes = {
  className: PropTypes.string,
  initialValue: PropTypes.string,
  onSubmit: PropTypes.func,
};

export default RemoteSessionForm;
